import { render, staticRenderFns } from "./DefaultFieldWidget.vue?vue&type=template&id=d83b52ce"
import script from "./DefaultFieldWidget.vue?vue&type=script&lang=js"
export * from "./DefaultFieldWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports